import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productImageAlt, productLabel } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden border-b border-line bg-navy-950" data-id="element-83" data-mp="4jvvvb7dj8w9">
      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-84" data-mp="127edzcmxdncx">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-fiber/40 bg-navy-900 px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white sm:text-sm" data-id="element-85" data-mp="xb5rfe6eervq">
          <ZapIcon className="h-4 w-4 shrink-0 text-fiber" aria-hidden="true" data-id="element-86" data-mp="381nuv9jxgt3y" /> {productLabel}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-87" data-mp="3j9283w7ie4z8">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full [filter:drop-shadow(0_0_28px_rgba(242,193,78,0.28))_drop-shadow(0_0_70px_rgba(44,203,246,0.18))]" data-id="element-88" data-mp="3e8egb8bghk3y" />
        </motion.div>

        <div className="mt-9" data-id="element-89" data-mp="359syjfdt6948">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-90" data-mp="35aud3tu19dqp">
            Get your professional edition now
          </Button>
        </div>
      </div>
    </section>;
}